// components/GameBoard.jsx
import React, { useRef, useCallback } from 'react';

const GameBoard = ({ level, onSwipe }) => {
  const touchStart = useRef({ x: 0, y: 0 });
  const touchEnd = useRef({ x: 0, y: 0 });

  const handleTouchStart = useCallback((e) => {
    touchStart.current = {
      x: e.touches[0].clientX,
      y: e.touches[0].clientY
    };
  }, []);

  const handleTouchEnd = useCallback((e) => {
    touchEnd.current = {
      x: e.changedTouches[0].clientX,
      y: e.changedTouches[0].clientY
    };

    const dx = touchEnd.current.x - touchStart.current.x;
    const dy = touchEnd.current.y - touchStart.current.y;
    const minSwipeDistance = 30;

    if (Math.abs(dx) > minSwipeDistance || Math.abs(dy) > minSwipeDistance) {
      if (Math.abs(dx) > Math.abs(dy)) {
        // Horizontal swipe
        onSwipe(dx > 0 ? 'right' : 'left');
      } else {
        // Vertical swipe
        onSwipe(dy > 0 ? 'down' : 'up');
      }
    }
  }, [onSwipe]);

  const getCellClass = (cell) => {
    switch (cell) {
      case 'W': return 'cell-wall';
      case 'P': return 'cell-player';
      case 'PS': return 'cell-player-target';
      case 'B': return 'cell-box';
      case 'BS': return 'cell-box-target';
      case 'T': return 'cell-target';
      default: return 'cell-empty';
    }
  };

  const getCellSymbol = (cell) => {
    switch (cell) {
      case 'W': return '🧱';
      case 'P': return '👨';
      case 'PS': return '👨‍🎯';
      case 'B': return '📦';
      case 'BS': return '✅';
      case 'T': return '🎯';
      default: return '';
    }
  };

  return (
    <div 
      className="game-board"
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
      style={{ touchAction: 'none' }}
    >
      {level.map((row, rowIndex) => (
        <div key={rowIndex} className="game-row">
          {row.map((cell, colIndex) => (
            <div
              key={`${rowIndex}-${colIndex}`}
              className={`game-cell ${getCellClass(cell)}`}
            >
              {getCellSymbol(cell)}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default GameBoard;